import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RelatorioService } from './relatorio-service.service';
import { CommonModule } from '@angular/common';
import { ExportFileService } from '../../../../utils/export-file.service';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from "@angular/material/icon";

interface IReport {
  resumo?: IResume;
  mensagens: Array<IMensagem>
}

interface IResume {
  disparos: string;
  status: string;
  columnSelected: string;
  fileName: string;
  selectedSaturday: boolean;
  selectedSunday: boolean;
}

interface IMensagem {
  mensagem: string;
  numero: string;
  hourSend?: string;
  status: string;
}

@Component({
  selector: 'app-relatorio',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatIcon],
  templateUrl: './relatorio.component.html',
  styleUrls: ['./relatorio.component.scss'],
  providers: [RelatorioService, ExportFileService]
})
export class RelatorioComponent  implements OnInit {

  public dataReport!: IReport;
  public fullMessages: IMensagem[] = [];
  public displayedMessages: IMensagem[] = [];

  private chunkSize = 30;
  private chunkIndex = 0;
  public isLoadingMore = false;

  public selectTypeReport: "success" | "Pendente" = 'success';

  constructor(private route: ActivatedRoute, private relatorioService: RelatorioService, private exportFileService: ExportFileService) { }

  ngOnInit() {
    console.log("Executando antes de iniciar o componente");
    this.route.paramMap.subscribe(params => {
      if(params.get('iddisparo')) {
        let idReport: any = params.get('iddisparo')
        this.relatorioService.getReport(parseInt(idReport)).subscribe((response: any)=>{
          this.dataReport = response;
          this.fullMessages = response.mensagens;

          this.loadNextChunk();
        })
      }
    });
  }

  public exportarDados(){

    let newArrayDataExport = this.dataReport.mensagens.filter((element)=> element.status === this.selectTypeReport);
    this.exportFileService.exportAsExcelFile(newArrayDataExport);
  }

  public handleChangeFilter(event: Event){
    const valueElement = (event?.target as HTMLSelectElement);

    if(valueElement.value === 'success' || valueElement.value === "Pendente"){
      this.selectTypeReport = valueElement.value
    }
  }


  public loadNextChunk(){
    if(this.isLoadingMore) return;

    this.isLoadingMore = true;

    const start = this.chunkIndex * this.chunkSize;
    const end = start + this.chunkSize;

    const nextChunk = this.fullMessages.slice(start, end);

    this.displayedMessages.push(...nextChunk);

    this.chunkIndex++;

    this.isLoadingMore = false;
  }

  public onScroll(event: any){
    const element = event.target;

    const atBottom = element.scrollTop + element.clientHeight >= element.scrollHeight - 50;

    if(atBottom){
      this.loadNextChunk();
    }
  }



}
